/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CaptureSource = {
    Device: 'device',
    Manual: 'manual',
} as const;
export type CaptureSource = typeof CaptureSource[keyof typeof CaptureSource];


export function instanceOfCaptureSource(value: any): boolean {
    for (const key in CaptureSource) {
        if (Object.prototype.hasOwnProperty.call(CaptureSource, key)) {
            if (CaptureSource[key as keyof typeof CaptureSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CaptureSourceFromJSON(json: any): CaptureSource {
    return CaptureSourceFromJSONTyped(json, false);
}

export function CaptureSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureSource {
    return json as CaptureSource;
}

export function CaptureSourceToJSON(value?: CaptureSource | null): any {
    return value as any;
}

export function CaptureSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): CaptureSource {
    return value as CaptureSource;
}

